import React from "react";
import { BookOpenIcon, BrainIcon, ClockIcon, CompassIcon, SearchIcon, ShuffleIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { SectionHeading } from "../SectionHeading";
import { pains } from "../../data/content";
const iconMap = {
  compass: CompassIcon,
  clock: ClockIcon,
  shuffle: ShuffleIcon,
  search: SearchIcon,
  book: BookOpenIcon,
  brain: BrainIcon
};
export function PainSection() {
  return <section className="w-full bg-cream px-5 py-16 sm:py-24" data-id="element-234" data-mp="2hm68k7jghocg">
      <div className="mx-auto max-w-5xl" data-id="element-235" data-mp="2ctwlcz9q72dv">
        <SectionHeading title={<>If you’ve ever looked at a new case and thought…</>} data-id="element-236" data-mp="2cs217n6a3eau" />

        <ul className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-237" data-mp="28st88kj2bkgc">
          {pains.map(p => {
          const Icon = iconMap[p.icon];
          return <li key={p.title} className="flex gap-4 rounded-2xl border border-gold-300 bg-white p-5" data-id="element-238" data-mp="1yt2dqiui55g9">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-navy-900" data-id="element-239" data-mp="1twlrxvarz36c">
                  <Icon className="h-5 w-5 text-gold-400" aria-hidden="true" data-id="element-240" data-mp="19rhiwhjlwlzy" />
                </span>
                <div data-id="element-241" data-mp="1ektu9pz9ywar">
                  <h3 className="font-serif text-lg font-bold leading-snug text-ink" data-id="element-242" data-mp="1elc2lkz7p0z1">{p.title}</h3>
                  <p className="mt-1.5 text-[15px] leading-relaxed text-muted" data-id="element-243" data-mp="zsrzulfz4vi4">{p.text}</p>
                </div>
              </li>;
        })}
        </ul>

        <div className="mx-auto mt-10 max-w-2xl text-center text-lg leading-relaxed text-ink/85" data-id="element-244" data-mp="1sjtiiwivl96e">
          <p data-id="element-245" data-mp="1xhv3xo3rxkl1">I understand that frustration. And I don’t think the answer is necessarily another 20-hour course.</p>
          <p className="mt-3 font-serif text-2xl font-bold text-navy-900" data-id="element-246" data-mp="1in70efhxow82">
            Sometimes what you need is a better process for working through the information you already have.
          </p>
        </div>

        <div className="mx-auto mt-10 max-w-xl" data-id="element-247" data-mp="78a88wqgdqwh">
          <CTAButton label="I want a structured case pathway" data-id="element-248" data-mp="c63axfsjs2s0" />
        </div>
      </div>
    </section>;
}